import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

import { AppSettings } from '~/core/models/appsettings';
import { AppConfigService } from './appconfig.service';

const FILE = "assets/appsettings.json";
const SETTINGS_KEY = "_AppSettings";

@Injectable({
    providedIn: 'root'
})
export class AppSettingsService {
    private http: HttpClient;

    constructor(
        private httpHandler: HttpBackend,
        private appConfigService: AppConfigService
    ) {
        this.http = new HttpClient(this.httpHandler);
    }

    public async init(): Promise<boolean> {
        const p = new Promise<boolean>(async (resolve, reject) => {
            try {
                let stream$ = this.http.get(FILE);

                lastValueFrom(stream$).then(async (data: any) => {
                    // Load config to get allowed groups
                    try {
                        await this.appConfigService.init();
                        const config = this.appConfigService.getConfig();
                        
                        // Merge allowed groups from config
                        if (config && config.allowedGroups && config.allowedGroups.length > 0) {
                            data.allowedGroups = config.allowedGroups;
                            console.log('Loaded allowedGroups from config:', data.allowedGroups);
                        }
                    } catch (configError) {
                        console.warn('Warning: Could not load config for allowedGroups:', configError);
                        // Continue even if config fails to load - allowedGroups will be empty
                    }
                    
                    this.saveSettings(data);

                    resolve(true);
                });
            } catch(error: any) {
                reject(error);
            }
        });

        return await p;
    }

    public async getSettings(initialize: boolean = false): Promise<AppSettings> {
        if (initialize) {
            await this.init();
        }

        let storage = sessionStorage.getItem(SETTINGS_KEY) ?? JSON.stringify(new AppSettings);

        return JSON.parse(storage);
    }

    public saveSettings(settings: AppSettings): Promise<void> {
        if (!settings.roles) {
            settings.roles = [];
        }

        // Override title to SDS IntelliRev Validator
        settings.title = "SDS IntelliRev Validator";

        return new Promise<void>((resolve) => {
            sessionStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));

            resolve();
        });
    }

    public clearSettings() {
        sessionStorage.removeItem(SETTINGS_KEY);
    }
}
